import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `TipoAlimentacion/cambioEstadoSeleccionTipoAlimentacion `, method: 'POST', body: {list}, token: token})
}
